import { render, staticRenderFns } from "./college.vue?vue&type=template&id=c795fd10&scoped=true&lang=pug&"
import script from "./college.vue?vue&type=script&lang=js&"
export * from "./college.vue?vue&type=script&lang=js&"
import style0 from "./college.vue?vue&type=style&index=0&id=c795fd10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c795fd10",
  null
  
)

export default component.exports